// import { sortBy } from "lodash";
import { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LinearProgress } from "@mui/material";
import { getAccounts } from "../../API/apiAuth";
import { QueryFilter, Response } from "../../Models/api";
import StoreStateModel from "../..//Models/store";
import { AccountModel } from "../../Models/account";
import SelectMUI from "../Selects/SelectMUI";

interface Props {
  onChange: (account: any) => void;
  onBlur?: (event: any) => void;
  error?: boolean;
  helperText?: string;
  autofillWithUserAccount?: boolean;
}

const SelectAccount = ({
  onChange,
  onBlur,
  helperText,
  error = false,
  autofillWithUserAccount = true,
}: Props) => {
  const [accountList, setAccountList] = useState<AccountModel[]>([]);
  const [hasNextPageUser, setHasNextPageUser] = useState<boolean>(true);
  const [isNextPageLoadingAccount, setIsNextPageLoadingAccount] = useState<boolean>(false);

  const userAccount = useSelector(
    (state: StoreStateModel) => ({
      id: state.auth.accountAssigned.id,
      name: state.auth.accountAssigned.name,
    }),
    shallowEqual
  );

  const initialAccount = autofillWithUserAccount && userAccount.id !== 0 ? userAccount : "";

  const [account, setAccount] = useState<any | AccountModel>(initialAccount);

  useEffect(() => {
    if (account) onChange(account);
  }, []);

  const cleanAccountData = () => {
    setHasNextPageUser(true);
    setIsNextPageLoadingAccount(false);
    setAccountList([]);
  };

  const loadNextAccounts = async (
    startIndex: number,
    stopIndex: number,
    pageCount: number,
    filterText: string
  ) => {
    const filter: QueryFilter = {
      pageSize: 10,
      pageNumber: pageCount,
      name: filterText,
    };

    setIsNextPageLoadingAccount(true);

    return await getAccounts(filter)
      .then((response: Response) => {
        const data2 = response.data.payload;
        let data: any[] = [];
        if (pageCount != 1) {
          data = [...accountList];
        }

        const temp = data.concat(data2).filter((account) => account.id !== 0);

        const total = response.data.totalRecords || 0;
        if (temp.length < total) {
          setHasNextPageUser(true);
        } else {
          setHasNextPageUser(false);
        }
        setIsNextPageLoadingAccount(false);
        setAccountList(temp);
      })
      .catch((e: any) => {
        //
      });
  };

  const onChangeHandler = (account: AccountModel) => {
    onChange && onChange(account);
    setAccount(account);
  };

  return (
    <SelectMUI
      getOptionLabel={(option: any) => `${option.name}  (${option.id})`}
      getOptionValue={(option: any) => option.id}
      label={"Accounts"}
      options={accountList as any}
      isMulti={false}
      backspaceRemovesValue={false}
      escapeClearsValue
      hideSelectedOptions
      noOptionsMessage={() => "Empty"}
      isLoading={false}
      isClearable
      isSearchable
      closeMenuOnSelect
      isDisabled={false}
      value={account}
      name="selectedAccount"
      onChangeEvent={onChangeHandler}
      onBlurEvent={onBlur}
      onMenuCloseEvent={cleanAccountData}
      vLoadNextPage={loadNextAccounts}
      virtualize={true}
      VLoadingComponent={LinearProgress}
      vTotalOfVisiblesRows={4}
      vWidthOfRows={45}
      vHasNextPage={hasNextPageUser}
      vIsNextPageLoading={isNextPageLoadingAccount}
      error={error}
      helperText={helperText}
    />
  );
};

export default SelectAccount;
